import { render } from "./boxFiles.vue?vue&type=template&id=1e42de0f&scoped=true"
import script from "./boxFiles.vue?vue&type=script&lang=js"
export * from "./boxFiles.vue?vue&type=script&lang=js"

import "./boxFiles.vue?vue&type=style&index=0&id=1e42de0f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e42de0f"]])

export default __exports__